import { styled, Box } from '@ltvco/refresh-lib/theme';

export const Container = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  maxWidth: 1200,
  margin: '0 auto',
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(2.5),
  overflow: 'visible',
  position: 'relative',

  [theme.breakpoints.down('sm')]: {
    padding: 0,
    borderRadius: theme.spacing(1),
  },
}));

export const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(0.25),
    gap: theme.spacing(1),
  },
}));

export const SummaryCards = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: theme.spacing(2.5),
  marginBottom: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(1.25),
    marginBottom: theme.spacing(0.25),
    padding: theme.spacing(1.25),
  },
}));

export const Card = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  background: theme.palette.background.default,
  borderRadius: theme.spacing(1),

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.25),
  },
}));

export const ChartContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.background.default,
  borderRadius: theme.spacing(1),
  height: 300,
  overflow: 'visible',
  position: 'relative',
  paddingTop: theme.spacing(1.25),
  userSelect: 'none',
  WebkitUserSelect: 'none',

  '& *': {
    userSelect: 'none',
    WebkitUserSelect: 'none',
    outline: 'none !important',
  },

  '& *:focus': {
    outline: 'none !important',
  },

  [theme.breakpoints.down('sm')]: {
    height: 150,
    paddingTop: theme.spacing(0.625),
    borderRadius: `0 0 ${theme.spacing(1)} ${theme.spacing(1)}`,
  },
}));

export const CustomTooltip = styled(Box)(({ theme }) => ({
  background: theme.palette.background.default,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1),
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  transform: 'translate(-50%, -100%)',
  marginTop: theme.spacing(-2),
}));

export const FixedMobileTooltip = styled(Box)<{ left: number; top: number }>(
  ({ left, top, theme }) => ({
    background: theme.palette.background.default,
    position: 'fixed',
    left: `${left}px`,
    top: `${top}px`,
    transform: 'translate(-50%, -100%)',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    zIndex: 10,
    pointerEvents: 'none',
    marginTop: theme.spacing(-2),
  }),
);
